/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */
import type { App } from 'vue'

// Plugins
import pinia from '../store/index.js'
import router from '../router'
import i18n from './i18n.js'
import notify from './toast.js'
import VueApexCharts from 'vue3-apexcharts'

import vuetify from './vuetify'

export async function registerPlugins(app: App) {
  app
    .use(pinia)
    .use(i18n)
    .use(router)
    .use(vuetify)
    .use(notify)
    .use(VueApexCharts)
}
